// The two published legal documents. They live in apps/web/public/legal/, which
// Vite copies verbatim into dist/ - so they are served from the app's own origin,
// need no API route, and are reachable without auth, which the pre-login OTP and
// registration screens require.
//
// Generated from docs/legal/*.docx by scripts/build-legal-pdfs.mjs.
export const TERMS_URL = '/legal/terms-and-conditions.pdf'
export const PRIVACY_URL = '/legal/privacy-policy.pdf'

// CardBook has no standalone Cookie Policy document. Cookie handling is covered
// by the Privacy Policy's "Cookies and Similar Technologies" section, so the
// cookie link resolves there until a separate document exists.
export const COOKIE_URL = PRIVACY_URL
